import gql from 'graphql-tag';

const UPDATE_PASSWORD = gql`
  mutation UPDATE_PASSWORD($oldPassword: String, $newPassword: String){
    updatePassword(oldPassword: $oldPassword, newPassword: $newPassword)
  }
`;

export default UPDATE_PASSWORD;



// WEBPACK FOOTER //
// ./src/graphql/mutations/updatePassword.mutation.js